import { get, post } from '@/utils/request';

export const LinhaiQueryBidder = (params) => {
  return post('/api/v1/linhai/query_bidder', params);
};
export const WenlingQueryBidder = (params) => {
  return post('/api/v1/wenling/query_bidder', params);
};
export const WenlingQueryBidder2 = (params) => {
  return post('/api/v1/wenling2/query_bidder', params);
};
export const TaizhoQueryBidder = (params) => {
  return post('/api/v1/taizho/query_bidder', params);
};

export const SaveContract = (params) => {
  return post('/api/v1/save_contract', params);
};

export const AnQingSaveContract = (params) => {
  return post('/api/v1/anqing/save_contract', params);
};

export const TaizhoSaveContract = (params) => {
  return post('/api/v1/taizhosave_contract', params);
};
export const GgbTemp = (name) => {
  return get(`/api/v1/ggb_temp/${name}`);
};

export const TianTaiQueryBidder = (params) => {
  return post('/api/v1/tiantai/query_bidder', params);
};

export const TzygQueryBidder = (params) => {
  return post('/api/v1/tzyg/query_bidder', params);
};

export const WenlingxzQueryBidder = (params) => {
  return post('/api/v1/wenlingxz/query_bidder', params);
};

export const AnQingCreateQR = (params) => {
  return post('/api/v1/anqing/createqr', params);
};

export const AnQingQueryQR = (params) => {
  return post('/api/v1/anqing/queryqr', params);
};

export const AnQingCreateQRNational = (params) => {
  return post('/api/v1/anqing/createqr_national', params);
};

export const AnQingQueryQRNational = (params) => {
  return post('/api/v1/anqing/queryqr_national', params);
};

export const AnQingMediumCaDecrypt = (params) => {
  return post('/api/v1/anqing/medium-ca-decrypt', params);
};
